<div
  class="row m-0"
  dropFile
  (files)="fileUploadModalService.filesDropped($event)"
>
  <div class="col-md-3">
    <div
      class="card bg-transparent border-0 shadow mt-3 p-3"
      style="min-height: 90vh"
    >
      <div class="card bg-transparent border-0">
        <div class="my-4 mt-1">
          <span
            class="badge bg-primary float-end clickable rounded-pill"
            (click)="openDetails($event)"
            *ngIf="version"
            >Version {{ version }}
          </span>
        </div>
        <div class="card-body p-1 py-0">
          <div class="d-flex">
            <img style="height: 33px" src="assets/folder.svg" alt="" />
            <h2 class="ms-3">Droplet</h2>
          </div>
        </div>
      </div>
      <button
        class="btn btn-sm btn-warning me-2 w-100 mt-1 text-start text-white"
        routerLink="uploads_sr"
        [hidden]="!('SR' | auth)"
      >
        Student Records
      </button>
      <button
        class="btn btn-sm btn-primary me-2 w-100 mt-2 text-start text-white"
        routerLink="uploads_sped"
        [hidden]="!('SPED' | auth)"
      >
        Special Education Records
      </button>
      <button
        class="btn btn-sm btn-success me-2 w-100 mt-2 text-start text-white"
        routerLink="uploads_er"
        [hidden]="!('HR' | auth)"
      >
        Employee Records
      </button>
      <button
        class="btn btn-sm btn-info me-2 w-100 mt-2 text-start text-white"
        routerLink="uploads_ar"
        [hidden]="!('AR' | auth)"
      >
        Administrative Records
      </button>

      <div class="card bg-transparent border-0 mt-4">
        <div class="card-body p-1">
          <div class="d-flex">
            <img style="height: 33px" src="assets/printer.svg" alt="" />
            <h2 class="ms-3">Virtual Printer</h2>
          </div>
        </div>
      </div>

      <button
        class="btn btn-sm btn-dark me-2 w-100 text-start"
        routerLink="uploads_all"
      >
        Recently Printed Document
      </button>
      <div class="card bg-transparent border-0 mt-4">
        <div class="card-body p-0">
          <div class="d-flex pb-2">
            <img style="height: 45px" src="assets/YFHNT.svg" alt="" />
          </div>
          <button
            class="btn btn-sm btn-warning me-2 w-100 mt-2 text-dark text-start btn-hover"
            (click)="searchRecord()"
          >
            Search Records in Browser
          </button>
          <button
            class="btn btn-sm btn-warning me-2 w-100 mt-1 text-dark text-start btn-hover"
            *ngIf="isElectron()"
            [ngSwitch]="downloadProgress.status"
            [disabled]="downloadProgress.status === DownloadStatus.DOWNLOADING"
          >
            <span *ngSwitchCase="DownloadStatus.NOT_STARTED">
              Checking for Updates...
            </span>
            <span *ngSwitchCase="DownloadStatus.DOWNLOADING">
              Downloading: {{ downloadProgress.progress }}%
            </span>
            <span *ngSwitchCase="DownloadStatus.COMPLETED" (click)="restartApp()" style="cursor: pointer;">
              Download Complete - Click to Restart
            </span>
            <span *ngSwitchCase="DownloadStatus.ERROR" (click)="checkForUpdates()" style="cursor: pointer;">
              Up to Date
            </span>
            <span *ngSwitchCase="DownloadStatus.NOT_AVAILABLE" (click)="checkForUpdates()" style="cursor: pointer;">
              Up to Date
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-9 ps-1">
    <router-outlet></router-outlet>
  </div>
</div>
